/** Base URL of the C# API (no trailing slash). */
export function getApiBase(): string {
  const raw = import.meta.env.VITE_API_URL?.trim();
  const base = raw && raw.length > 0 ? raw : "http://localhost:5200";
  return base.replace(/\/$/, "");
}

/**
 * Public URL for product files under the API `wwwroot/Products/...`.
 * Always absolute against `VITE_API_URL` so previews work on static hosting
 * (Vite’s `/api-static` proxy only exists in local dev).
 */
export function productMediaUrl(...pathSegments: string[]): string {
  const path =
    "/Products/" + pathSegments.map((s) => encodeURIComponent(s)).join("/");
  return `${getApiBase()}${path}`;
}

/**
 * Public URL for series testimonial files under API `wwwroot/ProductCategories/...`.
 */
export function productCategoryMediaUrl(...pathSegments: string[]): string {
  const path =
    "/ProductCategories/" +
    pathSegments.map((s) => encodeURIComponent(s)).join("/");
  return `${getApiBase()}${path}`;
}

/** Public URL for support ticket gallery files under `wwwroot/Ticket/...`. */
export function ticketMediaUrl(...pathSegments: string[]): string {
  const path =
    "/Ticket/" + pathSegments.map((s) => encodeURIComponent(s)).join("/");
  return `${getApiBase()}${path}`;
}

/** Public URL for Customer Voice attachments under `wwwroot/CustomerVoice/...`. */
export function customerVoiceMediaUrl(...pathSegments: string[]): string {
  const path =
    "/CustomerVoice/" + pathSegments.map((s) => encodeURIComponent(s)).join("/");
  return `${getApiBase()}${path}`;
}

/**
 * Base URL of the member/public web app (`web/`), used for links opened from Admin
 * (e.g. Remote login → `/remote-login?…`).
 *
 * Prefer `VITE_WEB_URL` on the admin deploy. If unset in the browser, derive from the
 * admin hostname (`beta.admin…` → `beta.reseller…`) so production never falls back to localhost.
 */
export function getWebBase(): string {
  const raw = import.meta.env.VITE_WEB_URL?.trim();
  if (raw && raw.length > 0) return raw.replace(/\/$/, "");

  if (typeof window !== "undefined") {
    const { protocol, hostname } = window.location;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:3011";
    }
    // beta.admin.xmegami.com → beta.reseller.xmegami.com
    // admin.xmegami.com → reseller.xmegami.com
    if (hostname.includes("admin.")) {
      return `${protocol}//${hostname.replace("admin.", "reseller.")}`;
    }
    return `${protocol}//${hostname}`;
  }

  return "http://localhost:3011";
}
